// extracted by mini-css-extract-plugin
export var stepActive = "_20-3";
export var stepCompleted = "_20-4";
export var stepConnectorLine = "_20-b";
export var stepIndicatorCircle = "_20-6";
export var stepIndicatorCircleCompleted = "_20-7";
export var stepIndicatorCircleDefault = "_20-8";
export var stepIndicatorTextCompleted = "_20-9";
export var stepIndicatorTextDefault = "_20-a";
export var stepPending = "_20-5";
export var wizardContainer = "_20-1";
export var wizardContent = "_20-2";
export var wizardModal = "_20-0";